import React, {  useState, useEffect, useContext } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { Button, Layout, MobileTabBar, Footer } from '../../../components';

import './profile.less';
import '../profile-general.less';
import '../../../components/Card/card.less';

import RightChevronIcon from '../../../assests/icons/right-chevron.icon';
import AtIcon from '../../../assests/icons/at.icon';
import PhoneIcon from '../../../assests/icons/phone.icon';
import PasswordIcon from '../../../assests/icons/password.icon';
import Check from '../../../assests/icons/check';
import { message, Tabs } from 'antd';
import { DimensionsContext } from '../../../context/dimensions.context';
import ProfileMenu from '../profilemenu';
import { customMessages } from 'utils';
import { getUserProfileInfo } from 'services/profile.service';

const { TabPane } = Tabs;

const Profile = () => {
  const { isTabletBig } = useContext(DimensionsContext);
  let history = useHistory();
  const [userInfo, setUserInfo] = useState(null);

  function getProfileInfo() {
    getUserProfileInfo()
      .then((result) => {
       setUserInfo(result);

      }).catch((response) => {
        message.error(customMessages.getMessage(response.responseCode));
      });
  }

  useEffect(() => {
    getProfileInfo();
  }, []);

  return (
    <Layout>
      <div className="profile-page profile-page--profile">
        <div className="container">
          <div className="profile-page__title">
            <h1 className="section__title">Profilim</h1>
          </div>
          <div className="content-wrapper">
           <ProfileMenu></ProfileMenu>
            <div className="profile-page__content">
              <div>
                <h2 className="box__title">Kullanıcı Bilgileri</h2>
                <div>
                  <div className="card">
                    <div>
                      <span className="card__title">Adınız ve Soyadınız</span>
                      <span className="card__text">{userInfo?.name}  {userInfo?.surname}</span>
                    </div>
                    <div>
                      <span className="card__title">Doğum Tarihi</span>
                      <span className="card__text">{userInfo?.birthDate}</span>
                    </div>
                    <div>
                      <span className="card__title">Sisteme Kayıtlı TC No</span>
                      <span className="card__text">{userInfo?.tckn}</span>
                    </div>
                    <div>
                      <span className="card__title">Nüfus Cüzdan Seri No</span>
                      <span className="card__text">{userInfo?.tcknSerialNumber}</span>
                    </div>
                  </div>
                  {/* <div>
                    <p className="info-text">
                      Kimlik bilgileriniz ile ilgili değişim taleplerinizi
                      iletmek için bize ulaşabilirsiniz.
                    </p>
                    <span className="info-text">
                      <AtIcon />
                      info@loremipsum.com.tr
                    </span>
                    <span className="info-text">
                      <PhoneIcon />0 212 637 82 65
                    </span>
                  </div> */}
                </div>
                <div>
                  <div className="card">
                    <div>
                      <span className="card__title">E-Posta Adresiniz</span>
                      <span className="card__text">{userInfo?.eMail}</span>
                    </div>
                  </div>
                  {/* <div>
                    <Button shape="round" type="ghost">
                      E-Posta Adresimi Değiştir
                    </Button>
                  </div> */}
                </div>
                {/* <div>
                  <div className="card card--password">
                    <div>
                      <PasswordIcon />
                      <p className="card__text">
                        Sistemde kayıtlı şifrenizi değiştirin.
                      </p>
                    </div>
                  </div>
                  <div>
                    <Button shape="round" type="ghost">
                      Şifremi Değiştir
                    </Button>
                  </div>
                </div> */}
              </div>
              {/* <div>
                <h2 className="box__title">Yetkiler</h2>
                <div className="card">
                  <ul>
                    <li>
                      <Check />
                      Rehbere yeni kayıt ekleyebilir, mevcut kayıtları
                      silebilirsiniz.
                    </li>
                    <li>
                      <Check />
                      Rehbere yeni kayıt ekleyebilir, mevcut kayıtları
                      silebilirsiniz.
                    </li>
                    <li>
                      <Check />
                      Yeni mesaj gönderimi yapabilirsiniz.
                      <span>
                        <strong>Geçerli gönderim limitiniz:</strong> 27.500 TL
                      </span>
                    </li>
                    <li>
                      <Check />
                      Sipariş tutarını faturaya yansıtarak paket satın alımı
                      yapabilirsiniz.
                      <span>
                        <strong>Geçerli satın alım limitiniz:</strong> 27.500 TL
                      </span>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default Profile;
